import { UIEvent } from 'react';
import { Box } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import { ComplianceCoverageEmployee } from './types';
import ComplianceAudienceCoverageContent from './ComplianceAudienceCoverageContent';

type ComplianceAudienceCoverageModalProps = {
  open: boolean;
  title: string;
  statusLabel?: string;
  statusColor?: 'success' | 'error' | 'warning' | 'default';
  loading: boolean;
  isLoadingMore: boolean;
  showStatuses: boolean;
  infoMessage?: string;
  coverageEntries: ComplianceCoverageEmployee[];
  hasMoreCoverageEntries: boolean;
  onClose: () => void;
  onLoadMore: () => void;
};

const ComplianceAudienceCoverageModal = ({
  open,
  title,
  statusLabel,
  statusColor = 'default',
  loading,
  isLoadingMore,
  showStatuses,
  infoMessage,
  coverageEntries,
  hasMoreCoverageEntries,
  onClose,
  onLoadMore,
}: ComplianceAudienceCoverageModalProps) => {
  const handleScroll = (event: UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    const remainingScroll = scrollHeight - scrollTop - clientHeight;

    if (remainingScroll <= 80 && hasMoreCoverageEntries && !isLoadingMore && !loading) {
      onLoadMore();
    }
  };

  return (
    <Modal
      isOpen={open}
      onToggle={onClose}
      hasCancelButton={false}
      modalSize="sm"
      title={title}
      titleAdornment={statusLabel ? <Badge color={statusColor}>{statusLabel}</Badge> : null}
    >
      <Box onScroll={handleScroll} sx={{ minHeight: 240, maxHeight: 480, overflowY: 'auto', pr: 0.5 }}>
        <ComplianceAudienceCoverageContent
          loading={loading}
          isLoadingMore={isLoadingMore}
          coverageEntries={coverageEntries}
          showStatuses={showStatuses}
          infoMessage={infoMessage}
        />
      </Box>
    </Modal>
  );
};

export default ComplianceAudienceCoverageModal;
